import { Auth } from 'aws-amplify';
import request from '../utils/request.utils';

export const signUp = async (username, password, email, phone_number) => {
  phone_number = parseInt(
    phone_number.replace('(', '').replace(')', '').replace('-', '')
  );
  return new Promise((resolve, reject) => {
    Auth.signUp({
      username: email,
      password,
      name: username,
      attributes: {
        phone_number: `+${phone_number}`,
      },
    })
      .then((user) => {
        resolve(user);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const signIn = async (username, password) => {
  return new Promise((resolve, reject) => {
    Auth.signIn(username, password)
      .then((user) => {
        resolve(user);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const signOut = async () => {
  return new Promise((resolve, reject) => {
    Auth.signOut()
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
};

export const confirmSignUp = async (username, code) => {
  return new Promise((resolve, reject) => {
    Auth.confirmSignUp(username, code)
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
};

export const listUsers = () =>
  request('/api/v1/cognito/users/unconfirmed', 'GET').then(({ data }) => data);

export const validateUser = (Username) =>
  request(
    `/api/v1/cognito/users/${encodeURIComponent(Username)}/confirm`,
    'POST'
  );

export const deleteUser = (Username) =>
  request(`/api/v1/cognito/users/${encodeURIComponent(Username)}`, 'DELETE');

export const completeSignUp = async (user, password) => {
  if (
    !user &&
    user.challengeName !== 'NEW_PASSWORD_REQUIRED' &&
    user.challengeName !== 'FORCE_CHANGE_PASSWORD'
  )
    return user;

  const { requiredAttributes } = user.challengeParam;
  const userCompletePassword = await Auth.completeNewPassword({
    user,
    password,
    requiredAttributes,
  });
  return userCompletePassword;
};
